import { API_URL } from '../config';
import { makeApiCall } from '../_common/api.utils';

export const fetchDateWiseSectionAttendanceData = async (data: any, methods: any) => {
	if (methods === 'Branches') {
		const URL = `${API_URL}BranchWiseAttendanceForToday`;
		console.log('Branch API URL:', URL);
		const requestData = {
			fetchBranchWiseDataToken: data,
		};
		console.log('Branch Request params:', data);
		return makeApiCall(URL, requestData);
	} else if (methods === 'Head Office') {
		const URL = `${API_URL}SectionWiseAttendanceForToday`;
		console.log('Section API URL:', URL);
		const requestData = {
			fetchDateWiseSectionAttendanceToken: data,
		};
		console.log('Section Request params:', data);
		return makeApiCall(URL, requestData);
	}
};
